import { AxiosResponse } from 'axios';
import axiosInstance from '../utils/axios';
import amplifyConfig from '../config';
import API_PATH from './endpoints';
import type { InformationType, CreateInformationParams, UpdateInformationParams, UpdateInformationParamsClient, DeleteInformationParams } from '../types/information';

const informationAPI = {
  /**
   * ログイン画面お知らせ一覧の取得
   * @return InformationType[]
   */
  getInformations: async () => {
    return axiosInstance.get<undefined, AxiosResponse<InformationType[]>>(amplifyConfig.apiGateway.URL + API_PATH.INFORMATION.INFORMATION_NO_TRADING_COMPANY_CODE);
  },
  /**
   * 編集用ログイン画面お知らせ一覧の取得
   * @return InformationType[]
   */
  getInformationsForManage: async () => {
    return axiosInstance.get<undefined, AxiosResponse<InformationType[]>>(amplifyConfig.apiGateway.URL + API_PATH.INFORMATION.INFORMATION_NO_TRADING_COMPANY);
  },
  /**
   * 緊急通知一覧の取得
   * @return InformationType[]
   */
  getTradingCompanyInformations: async () => {
    return axiosInstance.get<undefined, AxiosResponse<InformationType[]>>(amplifyConfig.apiGateway.URL + API_PATH.INFORMATION.INFORMATION_BY_TRADING_COMPANY_CODE);
  },
  /**
   * 編集用緊急通知一覧の取得
   * @return InformationType[]
   */
  getTradingCompanyInformationsForManage: async () => {
    return axiosInstance.get<undefined, AxiosResponse<InformationType[]>>(amplifyConfig.apiGateway.URL + API_PATH.INFORMATION.INFORMATION_TRADING_COMPANY);
  },

  /**
   * ログイン画面お知らせの作成
   * @param CreateInformationParams
   * @return InformationType
   */
  createInformation: async (params: CreateInformationParams) => {
    return axiosInstance.post<CreateInformationParams, AxiosResponse<InformationType>>(amplifyConfig.apiGateway.URL + API_PATH.INFORMATION.INFORMATION_NO_TRADING_COMPANY, params);
  },
  /**
   * 緊急通知の作成
   * @param CreateInformationParams
   * @return InformationType
   */
  createTradingCompanyInformation: async (params: CreateInformationParams) => {
    return axiosInstance.post<CreateInformationParams, AxiosResponse<InformationType>>(amplifyConfig.apiGateway.URL + API_PATH.INFORMATION.INFORMATION_TRADING_COMPANY, params);
  },

  /**
   * ログイン画面お知らせの更新
   * @param UpdateInformationParamsClient
   * @return InformationType
   */
  updateInformation: async (params: UpdateInformationParamsClient) => {
    const { id, order, message, isDraft } = params;
    return axiosInstance.put<UpdateInformationParams, AxiosResponse<InformationType>>(amplifyConfig.apiGateway.URL + API_PATH.INFORMATION.INFORMATION + '/' + String(id), {
      order,
      isDraft,
      message,
    });
  },

  /**
   * ログイン画面お知らせの削除
   * @param DeleteInformationParams
   * @return InformationType
   */
  deleteInformation: async (params: DeleteInformationParams) => {
    const { id } = params;
    return axiosInstance.delete<DeleteInformationParams, AxiosResponse<InformationType>>(amplifyConfig.apiGateway.URL + API_PATH.INFORMATION.INFORMATION + '/' + String(id));
  },
};

export default informationAPI;
